<template>
  <button v-ripple
          :class="getButtonStyle"
          @click="onClick($event)">
    <slot v-if="buttonStyle === 'default'"/>
    {{ text }}
    <slot v-if="buttonStyle === 'accent'"/>
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    buttonStyle: {
      type: String,
      default: 'default',
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
  computed: {
    getButtonStyle() {
      if (this.buttonStyle === 'accent') {
        return this.$style.accentButton;
      }

      return this.$style.defaultButton;
    },
  },
};
</script>

<style lang="scss" module>
@import "@/styles/variables.scss";

.accentButton {
  background: $accent-button-gradient;
  border: $accent-button-border;
  color: $white-color;
  font-family: $title-font;
  font-size: 2rem;
  line-height: 2.2rem;
  font-style: italic;
  text-align: center;
  box-shadow: $accent-button-shadow;
  outline: none;
  transition: all 0.25s ease-in-out;

  &:hover,
  &:focus,
  &:active {
    background: $accent-button-active-gradient;
    border: $accent-button-active-border;
  }

  &:disabled {
    background: $accent-button-disabled-gradient;
    border: $accent-button-disabled-border;
  }
}

.defaultButton {
  background: $white-color;
  border: $default-button-border;
  color: $default-button-text;
  font-family: $title-font;
  font-size: 2rem;
  line-height: 2.2rem;
  font-style: italic;
  text-align: center;
  outline: none;
  transition: all 0.25s ease-in-out;

  &:hover,
  &:focus,
  &:active {
    background: $default-button-active-color;
    border: $default-button-active-border;
  }

  &:disabled {
    background: $white-color;
    border: $default-button-disabled-border;
  }
}
</style>
